"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const SvgArchive = (props) => (React.createElement("span", { className: "anticon" },
    React.createElement("svg", Object.assign({ fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", className: "PayPing-icon" }, props),
        React.createElement("path", { d: "m21.928 6.512v15.938h-19.852v-15.938", strokeLinecap: "square" }),
        React.createElement("path", { d: "m23.25 1.5502h-22.5v4.0597h22.5z" }),
        React.createElement("path", { d: "m15.308 13.899-3.3087 3.3829-3.3087-3.3829" }),
        React.createElement("path", { d: "m12.001 16.113v-6.4432" }))));
exports.default = SvgArchive;
//# sourceMappingURL=Archive.js.map